(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jacq-home-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jacq-home-reviews')) {
  customElements.define('jacq-home-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('.je-review'));
      this.index = 0;
      this.track = this.querySelector('.je-reviews__slides');
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.slides.forEach(slide => this.resizeObserver.observe(slide));
      this.updateHeight();
      const controls = this.querySelector('.je-reviews__controls');
      controls.hidden = this.slides.length < 2;
      controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (button) this.show(this.index + Number(button.dataset.direction));
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target);
        if (index >= 0) this.show(index);
      });
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.ready = false;
    }
    updateHeight() {
      const active = this.slides[this.index];
      if (active) this.track.style.setProperty('--je-review-height', active.getBoundingClientRect().height + 'px');
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.updateHeight();
      const status = this.querySelector('[data-status]');
      status.textContent = status.dataset.status.replace('[current]', this.index + 1);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
